import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "../utils/smoothScroll";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  console.log("ScrollToTop rendered with pathname:", pathname);

  useEffect(() => {
    console.log("ScrollToTop triggered for pathname:", pathname);
    // Koristimo setTimeout da osiguramo da se stranica renderovala pre skrolovanja
    setTimeout(() => {
      scrollToTop();
      console.log("Scrolled to top");
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollToTop;